import { useEffect } from "react";

export const useDocumentTitle = (title: string) => {
  useEffect(() => {
    document.title = title || "Lucerna Health Platform";

    return () => {
      document.title = "Lucerna Health Platform";
    };
  }, [title]);
};
